import { makeStyles } from '@material-ui/styles'

export default makeStyles(() => ({
  modal: {
    width: 900,
    minHeight: 686
  }
}))
